<template>
  <addSetting :selectedSetting="selectedSetting" @close="close" v-if="addSetting && !deleteSetting"></addSetting>
  <deleteSetting :selectedSetting="selectedSetting" @close="close" v-else-if="!addSetting & deleteSetting"></deleteSetting>
  <v-card width="100%" height="100%" v-else outlined>
    <v-toolbar color="secondary" dark class="title" flat>
      <v-icon left>fas fa-cog</v-icon>
      Mount Forms App Settings
    </v-toolbar>
    <v-card-text>
        <!-- STATIC LIST -->
        <v-card outlined>
            <v-row no-gutters align="center">
                <v-col cols="12" class="subtitle-1">
                    <v-card flat color="grey lighten-3">
                        <i>
                            This first group of settings are hard-coded into the app and cannot be added or deleted, only modified.
                        </i>
                    </v-card>
                </v-col>
                <v-col cols="12">
                    <v-text-field color="secondary" outlined class="pt-2" label="Recipient Email" v-model="emailSetting.value"></v-text-field>
                </v-col>
            </v-row>
            <v-row no-gutters align="center">
                <v-col cols="12" class="pa-1">
                    <v-text-field color="secondary" outlined label="Calendar Link" v-model="calSetting.value"></v-text-field>
                </v-col>
            </v-row>
            <v-row no-gutters>
                <v-col cols="12" class="text-center text-sm-right pa-1">
                    <v-btn @click="updateChanges()" outlined color="accent">
                        <v-icon left small>fas fa-times</v-icon>
                        Update Above Settings
                    </v-btn>
                </v-col>
            </v-row>
        </v-card>
        <br>
        <!-- DYANMIC LIST -->
        <v-card outlined>
            <v-row no-gutters>
                <v-col cols="12" class="subtitle-1">
                    <v-card flat color="grey lighten-3">
                        <i>
                            This second group creates the dynamic list available on the 'Other Forms' portion of the App.
                        </i>
                    </v-card>
                </v-col>
                <v-col cols="12" class="text-right">
                    <v-btn outlined color="accent" class="ma-2" small @click="newSetting()">
                        <v-icon left>fas fa-plus-circle</v-icon>
                        Add Item
                    </v-btn>
                </v-col>
                <v-col cols="12" align="center">
                    <v-row no-gutters class="ma-1 accent lighten-1" v-if="$vuetify.breakpoint.mdAndUp">
                        <v-col md="6" class="text-left"><b>ITEM</b></v-col>
                        <v-col md="4" class="text-center"><b>CATEGORY</b></v-col>
                        <v-col md="1" class="text-center"><b>EDIT</b></v-col>
                        <v-col md="1" class="text-center"><b>DELETE</b></v-col>
                    </v-row>
                    <v-row no-gutters class="pa-1 submissions" v-for="item in dbSettings" :key="item.id">
                        <v-col cols="12" sm="6" class="text-center text-sm-left">{{item.item}}</v-col>
                        <v-col cols="12" sm="4" class="text-center">{{item.category}}</v-col>
                        <v-col cols="6" sm="1" class="text-center">
                            <v-btn icon outlined small color="secondary" @click="editSetting(item)">
                                <v-icon small>fas fa-edit</v-icon>
                            </v-btn>
                        </v-col>
                        <v-col cols="6" sm="1" class="text-center">
                            <v-btn icon outlined small color="secondary" @click="confirmDelete(item)">
                                <v-icon small>fas fa-trash</v-icon>
                            </v-btn>
                        </v-col>
                    </v-row>
                </v-col>
            </v-row>
        </v-card>
    </v-card-text>
  </v-card>
</template>

<script>
  import addSetting     from '@/components/adminComponents/addSetting'
  import deleteSetting  from '@/components/adminComponents/deleteSetting'
  export default {
    components: {
        addSetting, deleteSetting
    },
    data(){
        return {
            addSetting      : false,
            calSetting      : {},
            deleteSetting   : false,
            dbSettings      : [],
            emailSetting    : {},
            selectedSetting : {}
        }
    },
    created(){
        this.getSettings()
    },
    methods: {
        close(){
            this.addSetting         = false
            this.deleteSetting      = false
        },
        confirmDelete(setting){
            this.selectedSetting    = setting
            this.deleteSetting      = true
        },
        editSetting(setting){
            this.selectedSetting        = setting
            this.addSetting             = true
            this.selectedSetting.new    = false
        },
        getSettings(){
            this.calSetting     = this.getSettingsCalendar
            this.dbSettings     = this.getCustomSettings
            this.emailSetting   = this.getSettingsEmail
        },
        newSetting(){
            this.addSetting      = true
            this.selectedSetting = {
                category    : "",
                item        : "",
                value       : "",
                new         : true
            }
        },
        updateChanges(){
            let appSettings = []
            appSettings.push(this.calSetting)
            appSettings.push(this.emailSetting)
            this.$store.dispatch('saveSettings', appSettings)
        }
    },
    computed: {
        getCustomSettings(){
            return this.$store.getters.getSettings.filter(set => {
                return set.category != 'App'
            })
        },
        getSettingsCalendar(){
            return this.$store.getters.getSettingsCalendar
        },
        getSettingsEmail(){
            return this.$store.getters.getSettingsEmail
        }
    }
  }
</script>

<style scoped>
.submissions:nth-child(odd){
  background: #CCC;
}
</style>
